import axios from 'axios';
import { serviceConstants } from '../services/common/constants';
import { getUserAuthToken } from '../services/common/util';

const API_URL = serviceConstants.API_HOST_NAME;
const CALLBACK_BASE = `${API_URL}/lead/v1`;

const getAuthHeaders = () => {
    const token = getUserAuthToken();
    return {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    };
};

// Schedule a new callback
export const scheduleCallback = async (leadId, callbackData) => {
    try {
        const response = await axios.post(
            `${CALLBACK_BASE}/${leadId}/schedule-callback`,
            callbackData,
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Reschedule existing callback
export const rescheduleCallback = async (leadId, callbackData) => {
    try {
        const response = await axios.patch(
            `${CALLBACK_BASE}/${leadId}/reschedule-callback`,
            callbackData,
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Complete callback
export const completeCallback = async (leadId) => {
    try {
        const response = await axios.patch(
            `${CALLBACK_BASE}/${leadId}/complete-callback`,
            {},
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Cancel callback
export const cancelCallback = async (leadId) => {
    try {
        const response = await axios.delete(
            `${CALLBACK_BASE}/${leadId}/cancel-callback`,
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Get my callbacks (agent view)
export const getMyCallbacks = async (dateRange) => {
    try {
        const params = dateRange ? `?dateRange=${JSON.stringify(dateRange)}` : '';
        const response = await axios.get(
            `${CALLBACK_BASE}/callbacks/my${params}`,
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Get team callbacks (manager view)
export const getTeamCallbacks = async (filters = {}) => {
    try {
        const queryParams = new URLSearchParams();
        if (filters.status) queryParams.append('status', filters.status);
        if (filters.agent) queryParams.append('agent', filters.agent);
        if (filters.desk) queryParams.append('desk', filters.desk);
        if (filters.dateRange) queryParams.append('dateRange', JSON.stringify(filters.dateRange));

        const response = await axios.get(
            `${CALLBACK_BASE}/callbacks/team?${queryParams.toString()}`,
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Get callback statistics
export const getCallbackStats = async () => {
    try {
        const response = await axios.get(
            `${CALLBACK_BASE}/callbacks/stats`,
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

